import {config} from "../config";
import {handleResponse} from "../helpers/response";
import i18n from 'i18next';
import UIkit from 'uikit';


export const LOAD_DELIVERY_TYPES = 'LOAD_DELIVERY_TYPES';
export const SHOW_LOADER_DELIVERY_TYPES = 'LOAD_DELIVERY_TYPES';
export const HIDE_LOADER_DELIVERY_TYPES = 'HIDE_LOADER_DELIVERY_TYPES';
export const SET_DELIVERY_TYPES = 'SET_DELIVERY_TYPES';
export const PUT_FORM_DELIVERY_DATA = 'PUT_FORM_DELIVERY_DATA';
export const PUT_INPUT_SEARCH_NP = 'PUT_INPUT_SEARCH_NP';
export const SET_NP_CITIES='SET_NP_CITIES';
export const SUBMIT_ONLINE='SUBMIT_ONLINE';
export const VALIDATE_FORM_DATA = 'VALIDATE_FORM_DATA';
export const SET_NP_WAREHOUSES = 'SET_NP_WAREHOUSES';
export const SELECT_NP_WAREHOUSE =  'SELECT_NP_WAREHOUSE';
export const REDIRECT_TO_PAYMENT = 'REDIRECT_TO_PAYMENT';
export const REDIRECT_TO_OFFLINE_STATUS = 'REDIRECT_TO_OFFLINE_STATUS';
export const SETS_LOCAL_SHOP_ACTION = 'SETS_LOCAL_SHOP_ACTION';
export const PRELOAD_USER_DATA = 'PRELOAD_USER_DATA';
export const NP_LOADER_START = 'NP_LOADER_START';
export const HIDE_LOADER_CHECKOUT = 'HIDE_LOADER_CHECKOUT';

export function loadDeliveryTypes(){
    return (dispatch, getState) => {
        var link = config.apiUrl + 'api/deliveryTypes/'+i18n.language;
        dispatch(showLoaderDelieryTypes());
        fetch(link).then(handleResponse).then(json => {
            dispatch(setDeliveryTypes(json));
            dispatch(hideLoaderDeliveryTypes());
        })
    }
}


export function setDeliveryTypes(data){
    return {
        type: SET_DELIVERY_TYPES,
        deliveryTypes: data
    }
}

export function showLoaderDelieryTypes(){
    return {
        type: SHOW_LOADER_DELIVERY_TYPES
    }
}

export function hideLoaderDeliveryTypes(){
    return {
        type: HIDE_LOADER_DELIVERY_TYPES
    }
}

/**
 * validates and put Field data
 *
 * @param name
 * @param value
 * @returns {{name: *, type: string, value: *}}
 */
export function putField(name, value){
    return {
        type: PUT_FORM_DELIVERY_DATA,
        data: {'name': name, 'value': value}
    }
}

/**
 * Changes delivery type
 *
 * @param value
 * @returns {function(...[*]=)}
 */
export function changeDeliveryType(value){
    return (dispatch,getState) => {
        if (value === '1'){
            var link = config.apiUrl + 'api/get/local/commerces/'+i18n.language;
            dispatch(showNPLoader());
            fetch(link).then(handleResponse).then(json =>{
                dispatch(setLocalShops(json));
            })
        }
        dispatch(putField('delivery_type',value));
    }
}

export function setLocalShops(json) {
    return {
        type: SETS_LOCAL_SHOP_ACTION,
        data: json
    }
}

export function putInputSearch( value ) {
    return {
        type: PUT_INPUT_SEARCH_NP,
        value: value
    }
}



/**
 * Load np data
 *
 * @param value
 * @returns {function(...[*]=)}
 */
export function loadNPData( value ) {
    return (dispatch, getState) => {
        var link = config.apiUrl + 'api/get/reqion/list/';
        const formData = new FormData();
        formData.append("city", value);
        dispatch(showNPLoader());
        fetch(link, {method: 'POST', body: formData}).then(handleResponse).then(json => {
            dispatch(setNPCities(convertJsonNP(json)));
        })
    }
}


export function showNPLoader(){
    return {
        type: NP_LOADER_START
    }
}

export function loadNPWarehouses( ){
    return (dispatch, getState) => {
        var link = config.apiUrl + 'api/get/warehouses/list';
        const formData = new FormData();
        formData.append('type',  getState().checkoutInfo.formData.delivery_type);
        formData.append('city',  getState().checkoutInfo.formData.delivery_city.value);
        dispatch(showNPLoader());
        fetch(link, {method: 'POST', body: formData}).then(handleResponse).then(json => {
            // console.log("json np warehouses  ", json);
            dispatch(setNPWarehouses(json));
        });
    }
}

/**
 * Set np warehouses
 *
 * @param json
 * @returns {{warehouses: *, type: string}}
 */
export function setNPWarehouses(json) {
    return {
        type: SET_NP_WAREHOUSES,
        warehouses: json
    }
}

export function selectWarehouse(warehouse){
    return {
        type: SELECT_NP_WAREHOUSE,
        warehouse: warehouse
    }
}

/**
 * Preloads
 *
 * @returns {function(...[*]=)}
 */
export function preloadFormDataViaUser(){
    return (dispatch, getState) => {
        // console.log("159 159 159 ", getState().user );
        if  ( Object.keys(getState().user.userInfo).length ){
            dispatch(preloadUserData(getState().user.userInfo));
        }
    }
}

export function preloadUserData(data){
    return {
        type: PRELOAD_USER_DATA,
        data: data
    }
}

const convertJsonNP = (json) =>{
    var dataConverted = json.data.length && json.data[0].TotalCount?json.data[0].Addresses.map(itm => {
            return {value:itm.DeliveryCity, label: itm.Present}
    }):[{value:"0", label:"Not_found"}];
    // console.log("data converted >>>>> %%%%%%%%%%%%% ", dataConverted);
    return dataConverted;
}

export function setNPCities( cities ) {
    return {
        type: SET_NP_CITIES,
        data: cities
    }
}

export function submitCheckout(isOffline) {
    return (dispatch, getState) => {
        dispatch(validateForm());
        // console.log("104 104 104 getState ", getState());
        console.log('submitCheckout->checkoutInfo->0');
        if (!getState().checkoutInfo.hasError){
            console.log('submitCheckout->checkoutInfo->1');
            var link =  config.apiUrl + 'api/checkout/cart/';
            const formData = new FormData();
            formData.append('name',  getState().checkoutInfo.formData.firstName);
            formData.append('second_name',  getState().checkoutInfo.formData.secondName);
            formData.append( 'phone', getState().checkoutInfo.formData.phone?getState().checkoutInfo.formData.phone:'' );

            if ( getState().checkoutInfo.formData.email !== undefined ){
                formData.append( 'email', getState().checkoutInfo.formData.email );
            }

            if (getState().checkoutInfo.formData.delivery_type !== undefined){
                formData.append( 'deliveryType', getState().checkoutInfo.formData.delivery_type );
            }

            if ( getState().checkoutInfo.formData.delivery_type === '1' ){
                formData.append('shopId', getState().checkoutInfo.formData.local_shops.value);
            }
            else if(  getState().checkoutInfo.formData.delivery_type === '5'  ){
                console.log('submitCheckout->formData', getState().checkoutInfo.formData);
                // formData.append('street',  getState().checkoutInfo.formData.street?getState().checkoutInfo.formData.street:null )
                // formData.append('home_num',  getState().checkoutInfo.formData.home_num?getState().checkoutInfo.formData.home_num:null )
                // formData.append('flat_num',  getState().checkoutInfo.formData.flat_num?getState().checkoutInfo.formData.flat_num:null )
                // formData.append('build_num',  getState().checkoutInfo.formData.flat_num?getState().checkoutInfo.formData.build_num:'' )
                // formData.append('pod_num',  getState().checkoutInfo.formData.flat_num?getState().checkoutInfo.formData.pod_num:'' )
                formData.append('postName', 'Укрпошта');
                formData.append('postIndex',  getState().checkoutInfo.formData.postIndex?getState().checkoutInfo.formData.postIndex:'' )
                formData.append('regionName',  getState().checkoutInfo.formData.regionName?getState().checkoutInfo.formData.regionName:'' )
                formData.append('cityName',  getState().checkoutInfo.formData.cityName?getState().checkoutInfo.formData.cityName:'' )
                formData.append('streetName',  getState().checkoutInfo.formData.streetName?getState().checkoutInfo.formData.streetName:'' )
                formData.append('houseNumber',  getState().checkoutInfo.formData.houseNumber?getState().checkoutInfo.formData.houseNumber:'' )
                formData.append('apartmentNumber',  getState().checkoutInfo.formData.apartmentNumber?getState().checkoutInfo.formData.apartmentNumber:'' )
                console.log('formData', formData);  
            }
            else if(  getState().checkoutInfo.formData.delivery_type === '6'  ){
                formData.append('street',  getState().checkoutInfo.formData.street?getState().checkoutInfo.formData.street:null )
                formData.append('home_num',  getState().checkoutInfo.formData.home_num?getState().checkoutInfo.formData.home_num:null )
                formData.append('build_num',  getState().checkoutInfo.formData.flat_num?getState().checkoutInfo.formData.build_num:'' )
                formData.append('pod_num',  getState().checkoutInfo.formData.flat_num?getState().checkoutInfo.formData.pod_num:'' )
            }
            else if (getState().checkoutInfo.formData.delivery_type === '3'){
                formData.append( 'cityId', getState().checkoutInfo.formData.delivery_city.value );
                formData.append('cityName', getState().checkoutInfo.formData.delivery_city.label);
                formData.append('postId', getState().checkoutInfo.formData.np_warehouses.value);
                formData.append('postName', getState().checkoutInfo.formData.np_warehouses.label);
            }
            formData.append('description', getState().checkoutInfo.formData.description?getState().checkoutInfo.formData.description:'');
            formData.append('is_offline', isOffline);
            //alert(isOffline);
            formData.append('tok_', getState().user.userInfo._tok );
            fetch(link, {method: 'POST', body: formData}).then(handleResponse).then(json => {
                if ( isOffline ){
                    dispatch(redirectToOrderStatus(json));
                }else{
                    dispatch(redirectToPayment(json));
                }
            }).catch(json => {
                UIkit.notification(json, {status:'danger'});
                dispatch({
                    type: HIDE_LOADER_CHECKOUT
                })
            });

        }
    }
}

export function redirectToOrderStatus(json) {
    return {
        type: REDIRECT_TO_OFFLINE_STATUS,
        orderId: json.order_id
    }
}

export function redirectToPayment(json){
    return {
        type: REDIRECT_TO_PAYMENT,
        orderId: json.order_id
    }
}

export function validateForm(){
    return {
        type: VALIDATE_FORM_DATA
    }
}

export function submitForm( ){
    return {
        type: SUBMIT_ONLINE
    }
}